import styled from "styled-components"
import { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setSelectedItem, setSelectedSubItem } from "@/state/menuSlice"
import { useRouter } from "next/router"
import { ICONS } from "@repo/utils/constants"
import { getCssSizeValue } from "@repo/utils"
import { BREAKPOINTS } from "@repo/ui/themeSettings"
import { useScrollContext } from "@repo/ui/src/components/Scroll"
import useQueryElement from "@repo/ui/src/hooks/useQueryElement"
import Icon from "@repo/ui/src/components/common/Icon/Icon"

const StyledWrapper = styled.div`
	cursor: pointer;
	width: ${getCssSizeValue(106, BREAKPOINTS.MOBILE)};
	position: relative;

	@media (min-width: ${({ theme }) => theme?.breakpoints?.tablet}px) {
		width: ${getCssSizeValue(131, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		width: ${getCssSizeValue(131)};
	}
`

const StyledLogoWrapper = styled.div`
	.icon {
		max-width: unset;
	}
`

const Logo = ({ firstMenuItem }) => {
	const { open } = useSelector((state) => state.menu)
	const dispatch = useDispatch()
	const router = useRouter()
	const logoSvgWidth = useQueryElement("#logo-svg")?.clientWidth || 200
	const wrapperRef = useRef(null)
	const {
		instance: { __lenis },
	} = useScrollContext()

	const handleOnClick = () => {
		dispatch(setSelectedSubItem(null))
		if (router.asPath === "/") {
			if (open) {
				__lenis.scrollTo(0)
				router.push("/", "/", { scroll: false })
			} else {
				__lenis.scrollTo(0)
			}
		} else {
			router.push("/", "/", { scroll: false })
		}
	}

	return (
		<StyledWrapper
			ref={wrapperRef}
			width={logoSvgWidth}
			onMouseEnter={() => {
				dispatch(setSelectedItem(firstMenuItem))
			}}
			onClick={handleOnClick}
		>
			<StyledLogoWrapper className="logo-wrapper" width={logoSvgWidth}>
				<Icon name={ICONS.PLEO_DESIGN_MENU_LOGO} className="no-color" />
			</StyledLogoWrapper>
		</StyledWrapper>
	)
}

export default Logo
